module.exports = __webpack_public_path__ + "static/integrations-creatives-mobile-ad74458bf7138c9f755547a6966f0bfc.png";